import { render } from "./SpaceTagFilterComponent.vue?vue&type=template&id=3fbefc67&scoped=true&ts=true"
import script from "./SpaceTagFilterComponent.vue?vue&type=script&lang=ts"
export * from "./SpaceTagFilterComponent.vue?vue&type=script&lang=ts"

import "./SpaceTagFilterComponent.vue?vue&type=style&index=0&id=3fbefc67&lang=scss"
import "./SpaceTagFilterComponent.vue?vue&type=style&index=1&id=3fbefc67&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbefc67"]])

export default __exports__